import React, { useState, useEffect } from "react";
import Account from "./Account";
import MyTickets from "./MyTickets";
import MyReservations from "./MyReservations";
import More from "./More";
import { useAuth } from "../../context/AuthContext";
import { useLingui } from "@lingui/react";
import { t } from "@lingui/macro";

const UserDashboard = () => {
  const { i18n } = useLingui();
  const [activeTab, setActiveTab] = useState("Account");
  const { userEmail } = useAuth();

  useEffect(() => {
    console.log("Logged-in user email:", userEmail);
  }, [userEmail]);

  const renderContent = () => {
    switch (activeTab) {
      case "Account":
        return <Account userEmail={userEmail} />;
      case "Tickets":
        return <MyTickets />;
      case "Reservations":
        return <MyReservations />;
      case "More":
        return <More />;
      default:
        return <Account userEmail={userEmail} />;
    }
  };

  return (
    <div className="user-dashboard">
      <header className="dashboard-header">
        {/* Użycie obiektu z ID gwarantuje, że Lingui doda to jako nowy klucz */}
        <h1>{i18n._(t({ id: "user.dashboard.title", message: "User Dashboard" }))}</h1>
      </header>

      <nav className="dashboard-tabs">
        <button
          className={activeTab === "Account" ? "tab active" : "tab"}
          onClick={() => setActiveTab("Account")}
        >
          {i18n._(t({ id: "user.dashboard.tab.account", message: "Account" }))}
        </button>

        <button
          className={activeTab === "Tickets" ? "tab active" : "tab"}
          onClick={() => setActiveTab("Tickets")}
        >
          {i18n._(t({ id: "user.dashboard.tab.tickets", message: "Tickets" }))}
        </button>

        <button
          className={activeTab === "Reservations" ? "tab active" : "tab"}
          onClick={() => setActiveTab("Reservations")}
        >
          {i18n._(t({ id: "user.dashboard.tab.reservations", message: "Reservations" }))}
        </button>

        <button
          className={activeTab === "More" ? "tab active" : "tab"}
          onClick={() => setActiveTab("More")}
        >
          {i18n._(t({ id: "user.dashboard.tab.more", message: "More" }))}
        </button>
      </nav>

      <main className="dashboard-content">{renderContent()}</main>
    </div>
  );
};

export default UserDashboard;